import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type Forums } from "./types";

export default {
  init: (apiInfo: ModuleApiInfo, args: Forums.Api.InitRequest): Promise<HttpApiResponse<Forums.Api.InitResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/forums`, args),

  getPostPage: (
    apiInfo: ModuleApiInfo,
    args: Forums.Api.GetPostPageRequest
  ): Promise<HttpApiResponse<Forums.Api.GetPostPageResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/forums/posts`, args),

  addPost: (
    apiInfo: ModuleApiInfo,
    args: Forums.Api.AddPostRequest
  ): Promise<HttpApiResponse<Forums.Api.AddUpdatePostResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/forums/posts`, args),

  removePost: (apiInfo: ModuleApiInfo, ticketId: string): Promise<HttpApiResponse<Forums.Api.RemovePostResponse>> =>
    api.delete(apiInfo, `/api/site/v1/modules/forums/posts/${ticketId}`),

  addPostComment: (
    apiInfo: ModuleApiInfo,
    ticketId: string,
    args: Forums.Api.AddPostCommentRequest
  ): Promise<HttpApiResponse<Forums.Api.AddUpdatePostCommentResponse>> =>
    api.post(apiInfo, `/api/site/v1/modules/forums/posts/${ticketId}/comments`, args),

  getPostCommentPages: (
    apiInfo: ModuleApiInfo,
    args: Forums.Api.GetPostCommentsPageRequest
  ): Promise<HttpApiResponse<Forums.Api.GetPostCommentsResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/forums/posts/${args.ticketId}/comments`),

  removePostComment: (
    apiInfo: ModuleApiInfo,
    ticketId: string,
    ticketCommentId: string
  ): Promise<HttpApiResponse<Forums.Api.RemovePostCommentResponse>> =>
    api.delete(apiInfo, `/api/site/v1/modules/forums/posts/${ticketId}/comments/${ticketCommentId}`),

  // save: (
  //   apiInfo: ModuleIntegratedApiInfo,
  //   args: Forums.Api.SaveRequest
  // ): Promise<HttpApiResponse<Forums.Api.AddUpdateResponse>> =>
  //   api.put(apiInfo, `/api/site/v1/modules/forums`, args),

  updatePost: (
    apiInfo: ModuleApiInfo,
    args: Forums.Api.UpdatePostRequest
  ): Promise<HttpApiResponse<Forums.Api.UpdatePostResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/forums/posts`, args),

  updatePostComment: (
    apiInfo: ModuleApiInfo,
    ticketId: string,
    args: Forums.Api.UpdatePostCommentRequest
  ): Promise<HttpApiResponse<Forums.Api.UpdatePostCommentResponse>> =>
    api.put(apiInfo, `/api/site/v1/modules/forums/posts/${ticketId}/comments`, args)
};
